// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordConfirmation":"_384CC-CGy6PtfDmOGqzkUh","content":"_3qmKeasmXvjEEc8-2fyqyG","logo":"m_rH18RczulkSnUCDoiT","title":"_3v_9lNSBrRNvGFz_Ktgtm2"};